import React, {createContext, useContext} from "react"
import {withRouter, RouteComponentProps} from "react-router-dom"
import {PBHistory} from "@irati/utils/history"

interface HistoryContextValue {
  history: PBHistory
  location: RouteComponentProps["location"]
}

const HistoryContext = createContext<HistoryContextValue | null>(null)

interface HistoryProviderProps extends RouteComponentProps {
  children: React.ReactNode
}

const HistoryProviderComponent: React.FC<HistoryProviderProps> = ({history, location, children}) => {
  const value = React.useMemo(() => ({history: history as PBHistory, location}), [history, location])
  return <HistoryContext.Provider value={value}>{children}</HistoryContext.Provider>
}

export const HistoryProvider = withRouter(HistoryProviderComponent)

export const useHistory = (): HistoryContextValue => {
  const context = useContext(HistoryContext)
  if (!context) {
    throw new Error("useHistory must be used within a HistoryProvider")
  }
  return context
}
